let _history;

export default {
  init (history) {
    _history = history;
  },

  get() {
    return _history;
  }
};



// WEBPACK FOOTER //
// ./src/client/History.js